// @flow

import type {Article} from 'docs/data';

export const getRootPathForArticle = (article: Article): string =>
  article.format === 'markdoc' ? 'docs/content/' : 'site/views/docs/';
